module.exports = __webpack_public_path__ + "fonts/SuisseIntl-LightItalic.fc14c81.woff";